import {ValidationType} from './ValidationType'

export const UsersValidation = {
  ID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserDepartmentID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserName: {
    validationType: ValidationType.Username,
    isRequired: true,
    maxLength: 30,
    maxValue: 0
  },
  Password: {
    validationType: ValidationType.UserPassword,
    isRequired: true,
    maxLength: 30,
    maxValue: 0
  },
  PasswordChangePeriod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 5,
    maxValue: 32767
  },
  PasswordChangedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  LanguageID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  StartupForm: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  NegotiatorType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  AllowSignatoryChange: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DiaryView: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SyncOutlook: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DiarySyncLevel: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderSystem: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderContacts: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderFinancial: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderPropertyManagement: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderSales: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderLettings: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderAppointments: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderCertificates: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  EmailTasks: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ForeColor: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  BackColor: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  DisplayMessages: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SuppressProcessOutlookEmails: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Photo: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  Signature: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  BranchManager: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PasswordResetToken: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  LicenceNumber: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  }
};
